import type { SliceTemplateProps } from '@yoweb/prismic-slicemachine/slices/slicesTypes';
import MediaHeaderSlice, {
  MediaHeaderSliceType,
} from '@yoweb/prismic-slicemachine/slices/MediaHeaderSlice';
import SeoSlice, { SeoSliceType } from '@yoweb/prismic-slicemachine/slices/SeoSlice';
import FaqSlice from '@yoweb/prismic-slicemachine/slices/FaqSlice/FaqSlice';
import { FaqSliceType } from '@yoweb/prismic-slicemachine/slices/FaqSlice';
import DividerSlice from '@yoweb/prismic-slicemachine/slices/DividerSlice/DividerSlice';
import { DividerSliceType } from '@yoweb/prismic-slicemachine/slices/DividerSlice';
import ColoredCtaSectionSlice from '@yoweb/prismic-slicemachine/slices/ColoredCtaSectionSlice/ColoredCtaSectionSlice';
import { ColoredCtaSectionSliceType } from '@yoweb/prismic-slicemachine/slices/ColoredCtaSectionSlice';
import AppDownloadCtaSectionSlice from '@yoweb/prismic-slicemachine/slices/AppDownloadCtaSectionSlice/AppDownloadCtaSectionSlice';
import { AppDownloadCtaSectionSliceType } from '@yoweb/prismic-slicemachine/slices/AppDownloadCtaSectionSlice';
import ExplanationSectionSlice from '@yoweb/prismic-slicemachine/slices/ExplanationSectionSlice/ExplanationSectionSlice';
import { ExplanationSectionSliceType } from '@yoweb/prismic-slicemachine/slices/ExplanationSectionSlice';
import VerticalScrollCarouselSlice from '@yoweb/prismic-slicemachine/slices/VerticalScrollCarouselSlice/VerticalScrollCarouselSlice';
import { VerticalScrollCarouselSliceType } from '@yoweb/prismic-slicemachine/slices/VerticalScrollCarouselSlice';
import ProjectCardSlice from '@yoweb/prismic-slicemachine/slices/ProjectCardSlice/ProjectCardSlice';
import { ProjectCardSliceType } from '@yoweb/prismic-slicemachine/slices/ProjectCardSlice';
import CornerCardSectionSlice from '@yoweb/prismic-slicemachine/slices/CornerCardSectionSlice/CornerCardSectionSlice';
import { CornerCardSectionSliceType } from '@yoweb/prismic-slicemachine/slices/CornerCardSectionSlice';

export const WhatYouGetTemplate = ({ slice }: SliceTemplateProps) => {
  switch (slice.slice_type) {
    case SeoSliceType:
      return <SeoSlice slice={slice} />;

    case MediaHeaderSliceType:
      return <MediaHeaderSlice data-testid="assistants-video-hero" slice={slice} />;

    case FaqSliceType:
      return <FaqSlice background="sky" slice={slice} />;

    case DividerSliceType:
      return <DividerSlice slice={slice} />;

    case ExplanationSectionSliceType:
      return (
        <ExplanationSectionSlice
          slice={slice}
          pb={{ _: 128, md: 144 }}
          pt={{ _: 'large2', md: 'large3', lg: 'xl2' }}
        />
      );

    case VerticalScrollCarouselSliceType:
      return <VerticalScrollCarouselSlice slice={slice} background="base050" />;

    case ColoredCtaSectionSliceType:
      return <ColoredCtaSectionSlice slice={slice} />;

    case AppDownloadCtaSectionSliceType:
      return <AppDownloadCtaSectionSlice slice={slice} />;

    case ProjectCardSliceType:
      return <ProjectCardSlice slice={slice} />;

    case CornerCardSectionSliceType:
      return <CornerCardSectionSlice slice={slice} />;

    default:
      return null;
  }
};
